import { useEffect, useState, useRef } from 'react';
import { Button, Modal, Input, Checkbox, Col, Row, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './index.less';
import * as api from '@/services/users';

let moduleIdList: any[] = [];
const AddUser = (props: any) => {
  const { handleOK, handleCancel, addTitle, setUserInfo, userInfo } = props;

  // ****生命周期****
  useEffect(() => {
    return () => {
      // 每次组件卸载时，清空userInfo用户信息
      setUserInfo({});
    };
  }, []);
  useEffect(() => {
    getUserPerList();
  }, []);

  console.log('props', props);

  // 获取权限列表
  const [options, setOptions] = useState([]);
  const getUserPerList = async () => {
    const res = await api.getUserPerList({
      productCode: 'boss',
    });
    console.log('用户管理获取权限列表', res);
    if (res.code === 200 && res.success) {
      const optionArray: any = [];
      res.data.details.map((item: any) => {
        optionArray.push({
          label: item.name,
          value: item.id,
        });
      });
      console.log('用户管理获取权限列表', optionArray);
      setOptions(optionArray);
    } else {
      message.error('获取用户权限列表失败');
    }
  };

  // 输入框的内容
  const [inputPhoneStatus, setInputPhoneStatus] = useState('');
  const [inputNameStatus, setInputNameStatus] = useState('');
  const onInputPhone = (e: any) => {
    console.log('输入手机号', e.target.value);
    const phoneReg = /^1[0-9]{10}$/;
    if (phoneReg.test(e.target.value) === false || e.target.value === '') {
      // 手机号进行正则校验
      setInputPhoneStatus('error');
    } else {
      setInputPhoneStatus('');
    }
    setUserInfo({
      ...userInfo,
      phone: e.target.value,
    });
  };
  const onInputName = (e: any) => {
    if (e.target.value === '') {
      setInputNameStatus('error');
    } else {
      setInputNameStatus('');
    }
    if (e.target.value.length === 100) {
      message.warning('用户姓名最多填写100个字符');
    }
    console.log('输入名字', e.target.value);
    setUserInfo({
      ...userInfo,
      name: e.target.value,
    });
  };

  const onChange = (value: any) => {
    console.log('弹窗内对象', value);
    setUserInfo({
      ...userInfo,
      moduleIdList: value,
    });
  };
  const checked = true;

  return (
    <>
      <Modal
        title={addTitle}
        visible={true}
        onOk={() => handleOK()}
        onCancel={handleCancel}
        width={600}
        keyboard={true}
        wrapClassName="addUser"
      >
        <div className="modalContent inputUserName">
          <div className="inputLabel"> 手机号 </div>
          <div className="modalInput">
            <Input
              placeholder="输入手机号"
              onChange={onInputPhone}
              status={inputPhoneStatus === 'error' ? inputPhoneStatus : undefined}
              defaultValue={userInfo.phone ? userInfo.phone : ''}
              maxLength={11}
            />
            {inputPhoneStatus === 'error' ? (
              <span style={{ color: '#ff4d4f', fontSize: '12px' }}>请输入正确的手机号</span>
            ) : null}
          </div>
        </div>
        <div className="modalContent inputPhoneCall">
          <div className="inputLabel"> 姓名 </div>
          <div className="modalInput">
            <Input
              placeholder="姓名"
              onChange={onInputName}
              status={inputNameStatus === 'error' ? inputNameStatus : undefined}
              defaultValue={userInfo.name ? userInfo.name : ''}
              maxLength={100}
            />
            {inputNameStatus === 'error' ? (
              <div style={{ color: '#ff4d4f', fontSize: '12px' }}>姓名不能为空</div>
            ) : null}
          </div>
        </div>
        <div className="modalContent">
          <div className="inputLabel" style={{ marginLeft: '14px' }}>
            {' '}
            权限控制{' '}
          </div>
          {/* <div className="authority"><Checkbox name={'4'} onChange={onChange}>企业空间管理</Checkbox></div>
                    <div className="authority"><Checkbox name={'5'} onChange={onChange}>用户管理</Checkbox></div>
                    <div className="authority"><Checkbox name={'6'} onChange={onChange}>审查规则配置</Checkbox></div>
                    <div className="authority"><Checkbox name={'7'} onChange={onChange}>转换管理</Checkbox></div> */}
          <Checkbox.Group
            onChange={onChange}
            defaultValue={userInfo?.moduleIdList}
            style={{ paddingTop: '8px', paddingLeft: '18px' }}
            options={options}
          ></Checkbox.Group>
        </div>
      </Modal>
    </>
  );
};
export default AddUser;
